@if (reportData && workflowPublishedVersion) {
  <app-report [report]="reportData" [workflowPublishedVersion]="workflowPublishedVersion"></app-report>
}
